/** Shared pill-segment styles for header preference toggles (language, theme). */

export const NAV_SEGMENT_ROOT =
  'inline-flex shrink-0 items-center gap-0.5 rounded-full border p-[3px] backdrop-blur-md';

export function navSegmentShell(isDark: boolean) {
  return isDark ? 'border-white/[0.08] bg-black/35' : 'border-gray-200/70 bg-white/55 shadow-sm';
}

export function navSegmentActive(isDark: boolean) {
  return isDark
    ? 'bg-amber-400 text-amber-950 shadow-[0_1px_8px_rgba(251,191,36,0.35)]'
    : 'bg-amber-500 text-white shadow-[0_1px_8px_rgba(245,158,11,0.3)]';
}

export function navSegmentIdle(isDark: boolean) {
  return isDark
    ? 'text-slate-400 hover:bg-white/[0.06] hover:text-amber-200/90'
    : 'text-slate-500 hover:bg-amber-50/70 hover:text-amber-800';
}

export const NAV_SEGMENT_ICON_BTN =
  'inline-flex h-11 w-11 min-h-[44px] min-w-[44px] items-center justify-center rounded-full transition-all duration-200 ease-out lg:h-7 lg:w-7 lg:min-h-0 lg:min-w-0';

export const NAV_SEGMENT_LABEL_BTN =
  'inline-flex h-11 min-h-[44px] min-w-[2.75rem] items-center justify-center rounded-full px-2 text-[10px] font-bold leading-none tracking-wide transition-all duration-200 ease-out lg:h-7 lg:min-h-0 lg:min-w-[1.75rem] lg:px-1.5';

/** Active nav link gradient - aligned with header amber language/theme switches. */
export function navActiveLinkGradient(isDark: boolean) {
  return isDark
    ? 'linear-gradient(to right, #fcd34d, #fbbf24, #f59e0b)'
    : 'linear-gradient(to right, #fbbf24, #f59e0b, #d97706)';
}

export function navActiveLinkStyle(isDark: boolean): { background: string; boxShadow: string } {
  return {
    background: navActiveLinkGradient(isDark),
    boxShadow: isDark ? '0 1px 10px rgba(251, 191, 36, 0.38)' : '0 1px 10px rgba(217, 119, 6, 0.28)',
  };
}
